export default __webpack_public_path__ + "75b7b5582fda92e18d8c74dc5eb65218.svg";